export const DEFAULT_TIMEZONE = 'America/Los_Angeles';
export const PLACEHOLDER_GUID = "00000000-0000-0000-0000-000000000000";
export const TOKEN_KEY = 'authToken';
export const TOKEN_EXPIRY_KEY = 'authTokenExpiry';